'use strict';

var _nodeResolve_empty = {};

module.exports = _nodeResolve_empty;
